<template>
  <div id="app">
    <!-- <keep-alive> -->
      <router-view />
  </div>
</template>
<script>
export default {
  name: "App",
  mounted: {},
  mounted() {
    document.oncontextmenu = function(event) {
      event.preventDefault();
    };
    document.onkeydown = document.onkeyup = document.onkeypre;
    document.addEventListener("keydown", function(event) {
      return 123 != event.keyCode || (event.returnValue = false);
    });
  }
  
};
</script>
<style lang='stylus'>
@import './common/stylus/reset.styl';
</style>


// WEBPACK FOOTER //
// src/App.vue